// extracted by mini-css-extract-plugin
export default {"Text":"RemovedFromProjectV2Event-module__Text__VTtZG94","Text_1":"RemovedFromProjectV2Event-module__Text_1__Ojn_aFo","Text_2":"RemovedFromProjectV2Event-module__Text_2__yyekYgW"};